import { createSharedStoreHook } from 'shared-store-hook';

export const useFooterHeight = createSharedStoreHook();
